export default "__VITE_ASSET__894a4cc6__"